import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

interface MemberTypeSelectorProps {
    // Global member-type names (e.g. ["Member", "Coach"]) loaded from /members/types.
    memberTypes: string[];
    onChange?: (memberType: string) => void;
    value?: string;
    disabled?: boolean;
}

// Dropdown for assigning a member's type (Member = default, Coach). Mirrors
// MembershipCategorySelector; options come from the global member-type lookup.
const MemberTypeSelector: React.FC<MemberTypeSelectorProps> = ({
    memberTypes,
    onChange,
    value,
    disabled = false
}) => (
    <Select
        value={value}
        onChange={onChange}
        placeholder="Select a member type"
        disabled={disabled}
        data-testid="member-type-select"
    >
        {memberTypes.map((memberType) => (
            <Option key={memberType} value={memberType}>
                {memberType}
            </Option>
        ))}
    </Select>
);

export default MemberTypeSelector;
